import React from 'react';

export default function MaleInfertility() {
  return (
    <main className="section-container py-12">
      <div className="space-y-8">
        <section>
          <h1 className="text-4xl font-bold text-brand mb-6">
            Male Infertility: Surgical Sperm Retrieval (TESA, PESA, MICRO TESE)
          </h1>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Azoospermia is a condition where the male partner does not have sperms in the ejaculate. Till some years ago, the only option in such cases used to be sperm donation and Artificial insemination of wife using these donated sperm. Every couple and every man wants to have his own biological child and now it is possible for azoospermic men to father their genetic child by surgical sperm retrieval techniques.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            Dr. Priya Bhave Chittawar is trained in the surgical sperm retrieval techniques in India and abroad and the Reproductive Medicine Department has the distinction of the first micro dissection testicular sperm extraction baby of Madhya Pradesh.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-brand mb-4">The various ways to obtained sperms for ICSI in azoospermia are</h2>
          <ul className="list-disc pl-6 space-y-2 text-neutral/70">
            <li><strong>TESA (Testicular Sperm Aspiration):</strong> Sperms are aspirated from the testes using a thin needle and scalp vein set</li>
            <li><strong>PESA (Percutaneous Epididymal Sperm Aspiration):</strong> Sperms are aspirated from the epididymis using a small needle.</li>
            <li><strong>Micro Dissection testicular sperm extraction:</strong> Using an operating microscope and magnification between 40X to 100X, the testes is opened and dilated tubules are selectively removed. The tubules are milked and sperms obtained are processed and cultured for intracytoplasmic sperm injection in the lab.</li>
          </ul>
        </section>
      </div>
    </main>
  );
}
